<ng-container *ngTemplateOutlet="isAuthenticated ? authNav : unauthNav"></ng-container>
<ng-template #authNav>
  <shared-nav-app-root id="shared-nav-root" sso visible></shared-nav-app-root>
</ng-template>
<ng-template #unauthNav>
  <shared-nav-app-root id="shared-nav-root" visible></shared-nav-app-root>
</ng-template>
